import EmailPushTranslateViewModel from "./emailPushTranslateViewModel";
import NotificationUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/NotificationService/NotificationUpdateRequest";
import NotificationGetDetailResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/NotificationService/NotificationGetDetailResponse";
import NotificationTypeEnum from "@/api/dataSource/api/Spirit/Entities/Enums/NotificationTypeEnum";
import NotificationEnum from "@/api/dataSource/api/Spirit/Entities/Enums/NotificationEnum";

export default class CreateEmailPushViewModel {
    notificationId?: number = null;
    notificationType?: NotificationTypeEnum = null;
    type?: NotificationEnum = null;
    name?: string = '';
	fieldNames: Array<string> = null;
	translations: Array<EmailPushTranslateViewModel> = null;
	initLanguages(languages: string[]) {
		this.translations = languages.map(
			(x) =>
			  new EmailPushTranslateViewModel({
				langCode: x
			  })
		  );
	}
	toServerModel(): NotificationUpdateRequest {
		const req = new NotificationUpdateRequest({
			NotificationId: this.notificationId,
			NotificationType: this.notificationType,
			Name: this.name,
			Translations: this.translations.map(x=>x.toServerModel())
		});
		return req;
	}
	fromServerModel(model: NotificationGetDetailResponse) {
		this.notificationId = model.Id;
		this.notificationType = model.NotificationType;
		this.name = model.Name;
		this.type = model.Type;
		this.fieldNames = (model.FieldNames || []).map(x=>`{${x}}`);
		console.log('fromServerModel: ', model);
		this.translations.forEach(tr => {
			const serverTranslation = model.Translations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.text = serverTranslation.Text;
				tr.title = serverTranslation.Title;
			}
		});
	}
	isValidTemplate(): boolean {
		const isAllFieldsInTemplate = this.translations.every(tr => this.fieldNames.every(fn => tr.text.includes(fn)));
		return isAllFieldsInTemplate;
	}
}
